module.exports = __webpack_public_path__ + "img/sub_page_communication36.f4577379.png";